import React, { useState } from 'react'
import { changeEmailApi, changePasswordApi } from '../helper/apiHelper';
import toast from 'react-hot-toast';
const ChangeCred = ({ handleCloseCredentialsModal }) => {

    const [credentialType, setCredentialType] = useState('email');
    const [emailForm, setEmailForm] = useState({ oldEmail: '', newEmail: '', password: '' });
    const [passwordForm, setPasswordForm] = useState({ oldPassword: '', newPassword: '', email: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

 const handleEmailChange = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
        await changeEmailApi({
            oldEmail: emailForm.oldEmail,
            newEmail: emailForm.newEmail,
            password: emailForm.password
        });

        toast.success('Email updated successfully');
        handleCloseCredentialsModal();
    } catch (error) {
        console.error('Email change error:', error);
        toast.error(error || 'Failed to update email');
    } finally {
        setIsSubmitting(false);
    }
};

const handlePasswordChange = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
        await changePasswordApi({
            oldPassword: passwordForm.oldPassword,
            newPassword: passwordForm.newPassword,
            email: passwordForm.email
        });

        toast.success('Password updated successfully');
        handleCloseCredentialsModal();
    } catch (error) {
        console.error('Password change error:', error);
        toast.error(error || 'Failed to update password');
    } finally {
        setIsSubmitting(false);
    }
};

    return (
        <div className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-dialog-centered" style={{ zIndex: 11122 }}>
                <div className="modal-content radius-16 bg-base">
                    <div className="modal-header py-16 px-24 border-bottom">
                        <h1 className="modal-title fs-5">Change Credentials</h1>
                        <button type="button" className="btn-close" onClick={handleCloseCredentialsModal} />
                    </div>
                    <div className="modal-body p-24">
                        {/* Radio buttons for selection */}
                        <div className="mb-20">
                            <label className="form-label fw-semibold mb-12">Select Type</label>
                            <div className="d-flex gap-4">
                                <div className="form-check" style={{ display: "flex", gap: "0", alignItems: "center" }}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="credentialType"
                                        id="emailRadio"
                                        value="email"
                                        checked={credentialType === 'email'}
                                        onChange={(e) => setCredentialType(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="emailRadio">
                                        Change Email
                                    </label>
                                </div>
                                <div className="form-check" style={{ display: "flex", gap: "0", alignItems: "center" }}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="credentialType"
                                        id="passwordRadio"
                                        value="password"
                                        checked={credentialType === 'password'}
                                        onChange={(e) => setCredentialType(e.target.value)}
                                    />
                                    <label className="form-check-label" htmlFor="passwordRadio">
                                        Change Password
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* Conditional Forms */}
                        {credentialType === 'email' ? (
                            <form onSubmit={handleEmailChange}>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Old Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter old email"
                                        value={emailForm.oldEmail}
                                        onChange={(e) => setEmailForm({ ...emailForm, oldEmail: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">New Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter new email"
                                        value={emailForm.newEmail}
                                        onChange={(e) => setEmailForm({ ...emailForm, newEmail: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Enter your password"
                                        value={emailForm.password}
                                        onChange={(e) => setEmailForm({ ...emailForm, password: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                                    <button
                                        type="button"
                                        className="btn btn-secondary border border-secondary-600 text-md px-24 py-10 radius-8"
                                        onClick={handleCloseCredentialsModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary border border-primary-600 text-md px-32 py-10 radius-8"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Updating...' : 'Update Email'}
                                    </button>
                                </div>
                            </form>
                        ) : (
                            <form onSubmit={handlePasswordChange}>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Old Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Enter old password"
                                        value={passwordForm.oldPassword}
                                        onChange={(e) => setPasswordForm({ ...passwordForm, oldPassword: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">New Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Enter new password"
                                        value={passwordForm.newPassword}
                                        onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter your email"
                                        value={passwordForm.email}
                                        onChange={(e) => setPasswordForm({ ...passwordForm, email: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="d-flex align-items-center justify-content-end gap-3 mt-24">
                                    <button
                                        type="button"
                                        className="btn btn-secondary border border-secondary-600 text-md px-24 py-10 radius-8"
                                        onClick={handleCloseCredentialsModal}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary border border-primary-600 text-md px-32 py-10 radius-8"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Updating...' : 'Update Password'}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
        </div>
    )
}

export default ChangeCred
